module.exports = __webpack_public_path__ + "img/cart.3577c1eb.png";